import { ref } from '@vue/composition-api';
import type { Integration } from '@getaccept/lib-shared/src/integrations/types/integration';
import AuthorizeNetService from '../../services/authorizenet.service';
import { useRootStore } from '../../../store/root.store';

export const useAuthorizeNet = () => {
  const authorizeNet = ref<Integration>(undefined);
  const error = ref('');

  const rootStore = useRootStore();

  const loadAuthorizeNet = async () => {
    try {
      const integration: Integration = await AuthorizeNetService.fetchIntegration(
        rootStore.documentId,
        rootStore.recipientId,
        rootStore.authId
      );
      error.value = '';
      authorizeNet.value = integration;
    } catch (e) {
      error.value = e.message;
    }
  };

  return {
    authorizeNet,
    error,
    loadAuthorizeNet,
  };
};
